import { Modal, Button, Col, Row, Space, Typography, message } from "antd";
import { useState } from "react";
import { Guid } from "guid-typescript";
import RewardRedemptionsView from "../components/reward-redemptions/RewardRedemptionsView";
import RewardRedemptionManageDialog from "../components/reward-redemptions/RewardRedemptionManageDialog";
import { RewardRedemption } from "../repository/data.default";
import { getRewardRedemptionsExport } from "../repository/data.repository";
import { SearchQuery } from "../code/search-query/search-query";
import Loader from "../controls/Loader";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function RewardRedemptionsPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [manageOpen, setManageOpen] = useState(false);
  const [manageRecord, setManageRecord] = useState<
    RewardRedemption | undefined
  >(undefined);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());

  function onSearch(query: SearchQuery): void {
    setSearchQuery(query);
  }

  function onAction(key: string, record: RewardRedemption): void {
    if (key === "manage") {
      setManageRecord(record);
      setManageOpen(true);
    }
  }

  function onFinish(): void {
    setManageOpen(false);
    setManageRecord(undefined);
    setTriggerView(Guid.create().toString());
  }

  function onClose(): void {
    setManageOpen(false);
    setManageRecord(undefined);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading redemptions export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });

    getRewardRedemptionsExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Redemptions
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("RewardRedemptions", "view")}
            onClick={onDownloadExport}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <RewardRedemptionsView
          trigger={triggerView}
          onAction={(key, record) => onAction(key, record)}
          onSearch={onSearch}
        />
      </Col>
      <RewardRedemptionManageDialog
        open={manageOpen}
        record={manageRecord}
        onFinish={onFinish}
        onCancel={onClose}
      />
      {contextHolder}
    </Col>
  );
}

export default RewardRedemptionsPage;
